export default function TabWhap({ children }: { children: React.ReactNode }) {
  return (
    <div style={{
      maxHeight: "430px",
      width: "100%",
      overflow: "auto"
    }}>
      {children}
    </div>
  )
}
